export default __webpack_public_path__ + "static/media/sceduled.581f6358.svg";